var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "help",
    clipPath: "url(#clip0_6335_6969)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.0001 2.66699C8.64008 2.66699 2.66675 8.64033 2.66675 16.0003C2.66675 23.3603 8.64008 29.3337 16.0001 29.3337C23.3601 29.3337 29.3334 23.3603 29.3334 16.0003C29.3334 8.64033 23.3601 2.66699 16.0001 2.66699ZM17.3334 25.3337H14.6667V22.667H17.3334V25.3337ZM20.0934 15.0003L18.8934 16.227C17.9334 17.2003 17.3334 18.0003 17.3334 20.0003H14.6667V19.3337C14.6667 17.867 15.2667 16.5337 16.2267 15.5603L17.8801 13.8803C18.3734 13.4003 18.6667 12.7337 18.6667 12.0003C18.6667 10.5337 17.4667 9.33366 16.0001 9.33366C14.5334 9.33366 13.3334 10.5337 13.3334 12.0003H10.6667C10.6667 9.05366 13.0534 6.66699 16.0001 6.66699C18.9467 6.66699 21.3334 9.05366 21.3334 12.0003C21.3334 13.1737 20.8534 14.2403 20.0934 15.0003Z",
    fill: "#545454"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6335_6969"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.3630074bff97e5bf249088a58452ca69.svg";
export { ForwardRef as ReactComponent };